import { FuelType } from '@fleet-beat/api';

export interface TruckParametersDto {
  id?: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  bodyAssembly?: number;
  engineValue?: number;
  color?: string;
  engineAssembly?: number;
  axiesQuantity?: number;
  engineHorsepowerFrom?: number;
  engineHorsepowerTo?: number;
  fuelType?: FuelType;
  fuelTankValue?: number;
  payload?: number;
}
